import * as fields from 'containers/CompanyContainer/Forms/Fields';

export const formTemplates = {
    company : {
        fields : [
            { 
                label: 'Company Name',
                name: 'name',
                value: '',
                type: 'text'
            },
            {
                label: 'Description ',
                name: 'description',
                value: '',
                type: 'text'
            },
            {
                label: 'Street',
                name: 'street',
                value: '',
                type: 'text'
            },
            {
                label: 'City',
                name: 'city',
                value: '',
                type: 'text'
            },
            {
                label: 'Province',
                name: 'province',
                value: '',
                type: 'text'
            },
            {
                label: 'Postal Code',
                name: 'postalCode',
                value: '',
                type: 'text'
            },
            {
                label: 'Country',
                name: 'country',
                value: '',
                type: 'text'
            },
            {
                label: 'Contact First Name',
                name: 'firstName',
                value: '',
                type: 'text'
            },
            {
                label: 'Contact Last Name',
                name: 'lastName',
                value: '',
                type: 'text'
            },
            {
                label: 'Contact Email',
                name: 'email',
                value: '',
                type: 'text'
            },
            {
                label: 'Contact Phone',
                name: 'phone',
                value: '',
                type: 'text'
            },
            {
                label: 'Are you a provider?',
                name: 'isProvider',
                value: false,
                type: 'checkbox'
            }          
        ],
        conditionalFields: [
            {
                condition: 'isProvider',
                label: "Expertise",
                name: 'expertise',
                value: '',
                type: 'text'
            },
            {
                condition: 'isProvider',
                label: "Biography",
                name: 'biography',
                value: '',
                type: 'text'
            },
            {
                condition: 'isProvider',
                label: 'Certifications',
                name: 'certifications',
                itemName: 'Certification',
                value: [],
                type: 'object',
                fields: fields.fieldsCertifications,
                add: true
            }
        ]
    }
}


// WEBPACK FOOTER //
// ./src/js/reducers/formTemplates.js